export const defaultProps = {
    dotSize: 4,
    noteWidth: 120,
    noteTextOffset: 8,
    animate: true,
    motionStiffness: 90,
    motionDamping: 13,
}
